export const NoDataPlaceholder = '-' as const
